var debounce = require('debounce');

const SmallHeaderClass = 'small-header';



export function initializeStickyNavResize() {
    let FixedHeaders: StickyNavsHandler;
    const fixedItems = [].slice.call(document.querySelectorAll('[data-header-height]')) as Array<HTMLElement>;
    const stickySearchBarContainer = document.querySelector("[data-search-container]");
    const stickyDisplayToggle = document.querySelector("[data-search-toggle]");

    if (fixedItems) {
        FixedHeaders = new StickyNavsHandler(fixedItems);
    }

    window.addEventListener('resize', debounce(() => {
        if (FixedHeaders) {
            FixedHeaders.setHeightProperties();
        }
    }, 50));

    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener('scroll', () => {
        let headerHeight = FixedHeaders.activeHeight;

        let st = window.pageYOffset || document.documentElement.scrollTop;

        if (st > lastScrollTop && st > headerHeight) {
            FixedHeaders.addHeaderClass(SmallHeaderClass);
           
        }
        else {
            FixedHeaders.removeHeaderClass(SmallHeaderClass);
            
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }, false);
}


class StickyNavsHandler {
    items: Array<HTMLElement>;

    constructor(items: Array<HTMLElement>) {
        this.items = items;
        this.setHeightProperties();
    }

    setHeightProperties() {
        document.body.style.setProperty('margin-top', `${this.activeHeight}px`);
    }

    addHeaderClass(className: string) {
        this.items.forEach(item => {
            if (!item.classList.contains(className)) {
                item.classList.add(className);
            }
        });
    }

    removeHeaderClass(className: string) {
        this.items.forEach(item => {
            if (item.classList.contains(className)) {
                item.classList.remove(className);
            }
        });
    }

    get activeHeight() {
        let activeHeight = 0;

        this.items.forEach(item => {
            activeHeight = Math.max(activeHeight, item.offsetHeight);
        });

        return activeHeight;
    }
}